module.exports = __webpack_public_path__ + "static/img/PSD16-A.96860ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PSD16-A.png
// module id = qvFB
// module chunks = 1